export default {
    restBaseURL: "https://tickets.paymentconf.com/api"
}
